import apiClient from './api';
import { Context } from './contextService';

export interface MatrixItem {
  ley: string;
  articulo: string;
  categoria: string;
  grupo_delitos: string;
}

export interface LLMResult {
  applies: boolean;
  justification: string;
  confidence_score: number;
  responsible: string;
  processes: string;
  probability: number;
  impact: number;
  controls: string;
}

export interface AnalysisResult {
  id: number;
  workflow_stage: string;
  result: LLMResult | null;
  matrix_item: MatrixItem;
  previous_version_id: number | null;
  created_at: string;
  additional_context: string | null;

  // New workflow fields
  applicability_validated_at: string | null;
  applicability_validated_by: string | null;
  validated_applies: boolean | null;
  probability_score: number | null;
  impact_score: number | null;
  inherent_risk_score: number | null;
  inherent_risk_level: string | null;
  risk_assessed_by: string | null;
  ai_risk_justification: string | null;
}

export interface ProjectStats {
  total: number;
  pending: number;
  analyzing: number;
  completed: number;
  failed: number;
}

export interface AnalysisStats {
  total_items: number;
  applicable_items: number;
}

export interface Project {
  id: number;
  name: string;
  state: string;
  creation_date: string;
  owner: string;
  contexts: Context[];
  analysis_results: AnalysisResult[];
  stats?: ProjectStats;
}

export const getProjects = async (): Promise<Project[]> => {
  const { data } = await apiClient.get('/proyectos/');
  return data;
};

export const getProjectById = async (id: string): Promise<Project> => {
  const { data } = await apiClient.get(`/proyectos/${id}`);
  return data;
};

export const createProject = async (name: string): Promise<Project> => {
  const { data } = await apiClient.post('/proyectos/', { name, state: 'pendiente' });
  return data;
};

export const analyzeProject = async (projectId: string): Promise<{ message: string }> => {
  const { data } = await apiClient.post(`/proyectos/${projectId}/analyze`);
  return data;
};

export const getAnalysisStats = async (projectId: string): Promise<AnalysisStats> => {
  const { data } = await apiClient.get(`/proyectos/${projectId}/analysis-stats`);
  return data;
};

export const retryFailedAnalyses = async (projectId: string): Promise<{ message: string }> => {
  const { data } = await apiClient.post(`/proyectos/${projectId}/retry-failed`);
  return data;
}; 